<template>
  <div class="home">
    <el-row>
      <el-col :span="4" class="left-sidebar">
        <div class="sidebar">
          <div class="text">
            <div class="logo-title-container">
              <img src="@/assets/lo.png" style="height:30px;width: 30px; margin-right: 5px;">
              <span class="logo-text">山东欧曼谛学生成长手册</span>
            </div>
          </div>
        </div>
        <div>
          <NavigationBar></NavigationBar>
        </div>
      </el-col>

      <el-col :span="20" class="main-content">
        <div class="navigation clearfix">
          <div class="align-container">
            <div class="expand">
              <i slot="suffix" class="el-icon-s-unfold"></i>
            </div>
            <el-breadcrumb separator="/" class="breadcrumb">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{ currentBreadcrumb }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="avatar-container" @click="showDialog">
            <span class="nick-name">{{ nickName }}</span>
            <el-image :src="getimage(imageUrl)"></el-image>
          </div>
        </div>

        <el-drawer title="个人信息" :visible.sync="drawer" :with-header="false" :size="500">
          <PersonView></PersonView>
        </el-drawer>

        <div class="content-wrapper">
          <component :is="currentPageComponent"></component>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import indexview from '../js/indexview';
export default {
  ...indexview
}
</script>

<style scoped>
.home {
  height: 100vh;
  width: 100%;
  position: relative;
}

/* 左侧导航栏样式 */
.left-sidebar {
  background-color:#333; ; /* 若依框架导航栏背景色 */
  min-height: 100vh;
}

/* logo和标题容器 - 防止换行 */
.logo-title-container {
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 0 10px;
}

.logo-img {
  height: 30px;
  width: 30px;
  border:1px solid red;
  display:block;
  
}

.logo-text {
  font-size: 16px; /* 常见字体大小 */
  font-weight: bold;
  color: white;
}

.text {
  padding: 20px 10px;
  border: none;
  color: white;
  height: 60px; /* 若依框架导航栏高度 */
  display: flex;
  align-items: center;
}

/* 右侧主内容区 */
.main-content {
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 - 若依框架样式 */
.navigation {
  height: 50px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.align-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.nick-name {
  color: var(--primary-color);
  font-size: 14px; /* 常见字体大小 */
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.avatar-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar-container .el-image {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--primary-color);
}

.expand {
  cursor: pointer;
  color: var(--primary-color);
  transition: color 0.3s ease;
  font-size: 20px;
}

.breadcrumb {
  flex: 1;
  margin-left: 20px;
  font-size: 14px; /* 常见字体大小 */
  line-height: 60px;
}

/* 内容区 - 文字靠左 */
.content-wrapper {
  /* background-color: #f0f2f5; */
  flex: 1;
  overflow: auto;
  text-align: left;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .logo-text {
    font-size: 14px;
  }
  
  .text {
    padding: 15px 5px;
    height: 50px;
  }
  
  .nick-name {
    font-size: 12px;
    padding: 3px 6px;
  }
  
  .avatar-container .el-image {
    width: 30px;
    height: 30px;
  }
  
  .breadcrumb {
    font-size: 12px;
    margin-left: 10px;
  }
  
  .navigation {
    padding: 0 10px;
  }
}
</style>